import dayjs from "dayjs";

/**
 * Formatea un timestamp ISO a fecha/hora legible (es-CO).
 */
export function formatDateTime(value: string | null | undefined) {
  if (!value) return "—";
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("DD/MM/YYYY HH:mm") : "—";
}

/**
 * Resize long texts and add ...
 */
export function resizeText(text: any, maxLength: number) {
  if (!text) return "";
  if (text.length > maxLength) {
    return text.slice(0, maxLength) + "...";
  }
  return text;
}
